module.exports = __webpack_public_path__ + "img/qroffical.63620806.jpg";